/* eslint-disable max-len */

import React from "react";

import { string } from "prop-types";

const Twitter = ({ height = "32", width = "32", primaryColor = "#FFFFFF", backgroundColor = "#0F1419" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" height={height} width={width} viewBox="0 0 24 24" xmlSpace="preserve">
    <circle fill={backgroundColor} cx="12" cy="12" r="10" />
    <path
      fill={primaryColor}
      d="M15.531,7h1.662l-3.63,4.236L17.833,17h-3.343l-2.62-3.495L8.876,17H7.212l3.882-4.531L7,7h3.427
	l2.366,3.195L15.531,7z M14.947,15.986h0.92L9.926,7.962H8.937L14.947,15.986z"
    />
  </svg>
);

Twitter.propTypes = {
  height: string,
  width: string,
  primaryColor: string,
  backgroundColor: string,
};

const Facebook = ({ height = "32", width = "32", primaryColor = "#FFFFFF", backgroundColor = "#1877F2" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" height={height} width={width} viewBox="0 0 24 24" xmlSpace="preserve">
    <circle fill={backgroundColor} cx="12" cy="12" r="10" />
    <path
      fill={primaryColor}
      d="M13.25,12.938h1.562l0.625-2.5H13.25v-1.25c0-0.644,0-1.25,1.25-1.25h0.938v-2.1
	c-0.204-0.027-0.973-0.088-1.786-0.088c-1.697,0-2.902,1.036-2.902,2.937v1.75H8.875v2.5h1.875v5.313h2.5V12.938z"
    />
  </svg>
);

Facebook.propTypes = {
  height: string,
  width: string,
  primaryColor: string,
  backgroundColor: string,
};

const Youtube = ({ height = "32", width = "32", primaryColor = "#FFFFFF", backgroundColor = "#FF0000" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" height={height} width={width} viewBox="0 0 24 24" xmlSpace="preserve">
    <path
      fill={backgroundColor}
      d="M12,2c5.523,0,10,4.477,10,10c0,5.523-4.477,10-10,10C6.477,22,2,17.523,2,12C2,6.477,6.477,2,12,2z"
    />
    <path
      fill={primaryColor}
      d="M17.964,8.561C18.25,9.675,18.25,12,18.25,12s0,2.325-0.286,3.439c-0.159,0.616-0.623,1.1-1.211,1.264
	C15.685,17,12,17,12,17s-3.683,0-4.753-0.298c-0.591-0.166-1.054-0.65-1.211-1.264C5.75,14.325,5.75,12,5.75,12s0-2.325,0.286-3.439
	c0.159-0.616,0.623-1.1,1.211-1.264C8.317,7,12,7,12,7s3.685,0,4.753,0.298C17.344,7.464,17.808,7.948,17.964,8.561z M10.75,14.188
	L14.5,12l-3.75-2.188V14.188z"
    />
  </svg>
);

Youtube.propTypes = {
  height: string,
  width: string,
  primaryColor: string,
  backgroundColor: string,
};

const Whatsapp = ({ height = "32", width = "32", primaryColor = "#FFFFFF" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" height={height} width={width} viewBox="0 0 24 24" xmlSpace="preserve">
    <linearGradient
      id="whatsappGradient"
      gradientUnits="userSpaceOnUse"
      x1="12"
      y1="24"
      x2="12"
      y2="4"
      gradientTransform="matrix(1 0 0 -1 0 26)"
    >
      <stop offset="0" style={{ stopColor: "#60D66A" }} />
      <stop offset="1" style={{ stopColor: "#20B038" }} />
    </linearGradient>
    <path
      fill="url(#whatsappGradient)"
      d="M12,22C6.478,22,2,17.522,2,12C2,6.478,6.478,2,12,2c5.522,0,10,4.478,10,10
	C22,17.522,17.522,22,12,22z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill={primaryColor}
      d="M16.678,7.344c-1.24-1.242-2.892-1.926-4.65-1.928
	c-3.622,0-6.572,2.948-6.572,6.572c0,1.158,0.302,2.29,0.878,3.286l-0.932,3.406l3.484-0.914c0.96,0.524,2.04,0.8,3.14,0.8h0.002
	c3.622,0,6.57-2.948,6.572-6.572C18.602,10.238,17.92,8.586,16.678,7.344z M12.03,17.456h-0.002c-0.98,0-1.942-0.264-2.78-0.762
	l-0.2-0.118L6.98,17.118l0.552-2.016l-0.13-0.206c-0.546-0.87-0.836-1.874-0.836-2.908c0.002-3.012,2.452-5.462,5.466-5.462
	c1.46,0,2.83,0.57,3.862,1.602c1.032,1.032,1.6,2.406,1.598,3.864C17.492,15.006,15.04,17.456,12.03,17.456z M15.026,13.364
	c-0.164-0.082-0.972-0.48-1.122-0.534c-0.15-0.054-0.26-0.082-0.37,0.082c-0.11,0.164-0.424,0.534-0.52,0.644
	c-0.096,0.11-0.192,0.124-0.356,0.042c-0.164-0.082-0.694-0.256-1.32-0.816c-0.488-0.436-0.818-0.974-0.914-1.138
	c-0.096-0.164-0.01-0.254,0.072-0.336c0.074-0.074,0.164-0.192,0.246-0.288c0.082-0.096,0.11-0.164,0.164-0.274
	c0.054-0.11,0.028-0.206-0.014-0.288c-0.042-0.082-0.37-0.89-0.506-1.22c-0.134-0.32-0.268-0.276-0.37-0.282
	C9.92,8.952,9.81,8.949,9.702,8.949c-0.11,0-0.288,0.042-0.438,0.206c-0.15,0.164-0.574,0.562-0.574,1.37
	c0,0.808,0.588,1.59,0.67,1.698c0.082,0.11,1.158,1.768,2.806,2.48c0.392,0.17,0.698,0.27,0.936,0.346
	c0.394,0.126,0.752,0.108,1.034,0.066c0.316-0.048,0.972-0.398,1.108-0.78c0.136-0.384,0.136-0.712,0.096-0.78
	C15.3,13.488,15.19,13.448,15.026,13.364z"
    />
  </svg>
);

Whatsapp.propTypes = {
  height: string,
  width: string,
  primaryColor: string,
};

const Share = ({ height = "32", width = "32" }) => (
  <svg height={height} width={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" xmlSpace="preserve">
    <circle fill="#FFCDD2" cx="12" cy="12" r="10" />
    <path
      fill="#D60000"
      d="M11.469,14.016h-1.094c-0.897,0-1.777,0.245-2.545,0.708c-0.768,0.464-1.395,1.128-1.812,1.922
	C6.006,16.499,6,16.351,6,16.203c0-3.02,2.448-5.469,5.469-5.469V8l5.469,4.375l-5.469,4.375V14.016z"
    />
  </svg>
);

Share.propTypes = {
  height: string,
  width: string,
};

const FontIncrease = ({ lang, height = "32", width = "32", backgroundColor = "#3681CF", primaryColor = "#FFFFFF" }) =>
  lang === "en" ? (
    <svg height={height} width={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" xmlSpace="preserve">
      <path
        fill={backgroundColor}
        d="M12,2c5.523,0,10,4.477,10,10c0,5.523-4.477,10-10,10C6.477,22,2,17.523,2,12C2,6.477,6.477,2,12,2z"
      />
      <path
        fill={primaryColor}
        d="M9.273,10.14l-1.812,5.525H6L8.476,9h0.929L9.273,10.14z M10.779,15.665L8.962,10.14L8.816,9h0.938
	l2.491,6.665H10.779z M10.697,13.184v1.076h-3.52v-1.076H10.697z M17.092,11.952v1.149h-4.569v-1.149H17.092z M15.434,10.144v4.852
	h-1.25v-4.852H15.434L15.434,10.144z"
      />
    </svg>
  ) : (
    <svg height={height} width={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" xmlSpace="preserve">
      <circle fill={backgroundColor} cx="12" cy="12" r="10" />
      <path
        fill={primaryColor}
        d="M5.122,9L5,9.214l0.474,0.525h6.533v0.652c0,0.278,0.001,0.588,0.003,0.927
	c0.002,0.34,0.003,0.698,0.003,1.075v1.075c0,0.153,0.005,0.287,0.015,0.403c0.01,0.115,0.024,0.217,0.041,0.306
	c-0.027,0.007-0.039,0.01-0.036,0.01c-0.037-0.095-0.082-0.198-0.132-0.308c-0.051-0.11-0.107-0.223-0.168-0.339
	c-0.061-0.115-0.126-0.231-0.194-0.347c-0.068-0.115-0.139-0.224-0.214-0.326c0.051-0.278,0.047-0.576-0.013-0.894
	c-0.06-0.318-0.201-0.631-0.425-0.94c-0.139-0.194-0.289-0.352-0.451-0.474c-0.161-0.122-0.323-0.218-0.484-0.288
	c-0.161-0.07-0.317-0.117-0.466-0.143c-0.15-0.025-0.282-0.038-0.398-0.038c-0.177,0.003-0.339,0.029-0.486,0.076
	c-0.148,0.048-0.275,0.115-0.382,0.204c-0.107,0.088-0.191,0.195-0.252,0.321c-0.061,0.126-0.092,0.268-0.092,0.428v0.005
	c0,0.139,0.025,0.271,0.076,0.395c0.051,0.124,0.12,0.232,0.209,0.324c0.088,0.092,0.191,0.165,0.308,0.219
	c0.117,0.054,0.24,0.082,0.369,0.082c0.146,0,0.279-0.025,0.4-0.076c0.121-0.051,0.223-0.118,0.308-0.201
	c0.085-0.083,0.151-0.181,0.199-0.293c0.048-0.112,0.071-0.229,0.071-0.351c0-0.041-0.002-0.066-0.005-0.076
	c0.013-0.003,0.037-0.005,0.071-0.005c0.115,0,0.227,0.022,0.336,0.066c0.109,0.044,0.2,0.11,0.275,0.199
	c0.027,0.065,0.048,0.156,0.061,0.275c0.014,0.119,0.01,0.248-0.01,0.387c-0.02,0.139-0.063,0.282-0.127,0.428
	c-0.064,0.146-0.16,0.277-0.285,0.392c-0.289,0.262-0.627,0.392-1.014,0.392c-0.228,0-0.461-0.048-0.701-0.145
	c-0.239-0.097-0.469-0.242-0.688-0.436c-0.219-0.194-0.42-0.436-0.604-0.729c-0.183-0.292-0.335-0.634-0.454-1.024
	c-0.095-0.153-0.182-0.297-0.26-0.433c-0.078-0.136-0.141-0.25-0.188-0.342c-0.044,0.007-0.108,0.026-0.191,0.056
	c-0.083,0.031-0.147,0.059-0.191,0.087c0.038,0.122,0.083,0.272,0.138,0.448c0.054,0.177,0.117,0.367,0.188,0.571
	c0.071,0.204,0.152,0.415,0.242,0.634c0.09,0.219,0.189,0.43,0.298,0.634c0.173,0.33,0.363,0.614,0.568,0.853
	c0.205,0.24,0.419,0.436,0.642,0.589c0.222,0.153,0.45,0.266,0.683,0.339c0.232,0.073,0.463,0.109,0.69,0.109
	c0.312,0,0.609-0.064,0.889-0.194c0.28-0.129,0.524-0.314,0.731-0.555c0.224,0.143,0.438,0.318,0.642,0.527
	c0.204,0.209,0.365,0.461,0.484,0.757v0.01c0.006,0.005,0.013,0.011,0.021,0.018c0.024,0.02,0.056,0.048,0.096,0.084
	c0.054,0.047,0.112,0.099,0.173,0.153c0.011,0.01,0.022,0.02,0.033,0.029c0.05,0.044,0.098,0.087,0.146,0.129
	c0.058,0.051,0.1,0.088,0.127,0.112l0.372-0.26c-0.01-0.099-0.019-0.223-0.026-0.374c-0.007-0.151-0.012-0.319-0.015-0.504
	c-0.003-0.185-0.006-0.381-0.008-0.589c-0.002-0.207-0.003-0.416-0.003-0.627c0-0.17-0.001-0.362-0.003-0.576
	c-0.002-0.214-0.002-0.438-0.002-0.673c0-0.234-0.001-0.472-0.003-0.713c-0.002-0.241-0.003-0.474-0.003-0.698v-0.81h0.622
	l0.153-0.245L13.224,9H5.122z"
      />
      <path
        fill={primaryColor}
        d="M14.362,12.268c-0.042,0.063-0.081,0.122-0.115,0.176l-0.112,0.183l0.178,0.275h0.232
	c0.08,0,0.164-0.002,0.252-0.005c0.153,0,0.325-0.001,0.517-0.003c0.192-0.002,0.395-0.004,0.609-0.008
	c-0.003,0.214-0.005,0.415-0.005,0.604c0,0.189-0.002,0.356-0.005,0.502c-0.003,0.085-0.005,0.167-0.005,0.247v0.232l0.27,0.173
	c0.037-0.02,0.073-0.041,0.107-0.061c0.034-0.02,0.068-0.039,0.102-0.056c0.058-0.034,0.121-0.071,0.188-0.112
	c0.068-0.041,0.131-0.083,0.189-0.127c0-0.061,0.001-0.14,0.002-0.237l0.005-0.331l0.005-0.4c0.002-0.143,0.003-0.29,0.003-0.443
	c0.312,0,0.599-0.003,0.861-0.01c0.262-0.007,0.457-0.01,0.586-0.01c0.041-0.058,0.082-0.118,0.122-0.181
	c0.041-0.063,0.078-0.123,0.112-0.181l0.112-0.194l-0.194-0.255h-0.232c-0.08,0-0.162,0.002-0.247,0.005
	c-0.146,0.003-0.315,0.006-0.507,0.008c-0.192,0.002-0.395,0.004-0.609,0.008c0.003-0.207,0.005-0.405,0.005-0.594
	c0-0.189,0.002-0.356,0.005-0.502v-0.245c0-0.078,0.002-0.155,0.005-0.229l-0.27-0.173c-0.037,0.024-0.073,0.046-0.107,0.066
	l-0.102,0.061c-0.058,0.037-0.121,0.078-0.191,0.122c-0.07,0.044-0.132,0.087-0.186,0.127v0.234c0,0.143-0.002,0.313-0.005,0.51
	c-0.003,0.197-0.005,0.408-0.005,0.632c-0.153,0.003-0.303,0.006-0.448,0.008c-0.146,0.002-0.282,0.003-0.407,0.003h-0.581
	C14.45,12.145,14.405,12.205,14.362,12.268z"
      />
    </svg>
  );

FontIncrease.propTypes = {
  lang: string,
  height: string,
  width: string,
  backgroundColor: string,
  primaryColor: string,
};

const FontDecrease = ({ lang, height = "32", width = "32", backgroundColor = "#3681CF", primaryColor = "#FFFFFF" }) =>
  lang === "en" ? (
    <svg height={height} width={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" xmlSpace="preserve">
      <path
        fill={backgroundColor}
        d="M12,2c5.523,0,10,4.477,10,10c0,5.523-4.477,10-10,10C6.477,22,2,17.523,2,12C2,6.477,6.477,2,12,2z"
      />
      <path
        fill={primaryColor}
        d="M10.273,10.14l-1.812,5.525H7L9.476,9h0.929L10.273,10.14z M11.779,15.665L9.962,10.14L9.816,9h0.938
	l2.491,6.665H11.779z M11.697,13.184v1.076h-3.52v-1.076H11.697z M16.38,12.287v1.034h-2.587v-1.034H16.38z"
      />
    </svg>
  ) : (
    <svg height={height} width={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" xmlSpace="preserve">
      <circle fill={backgroundColor} cx="12" cy="12" r="10" />
      <path
        fill={primaryColor}
        d="M5,9.214L5.122,9h8.101l0.494,0.494l-0.153,0.245h-0.622v0.81c0,0.224,0.001,0.457,0.003,0.698
	c0.002,0.241,0.003,0.479,0.003,0.713c0,0.234,0.001,0.459,0.002,0.673c0.002,0.214,0.003,0.406,0.003,0.576
	c0,0.211,0.001,0.42,0.003,0.627c0.002,0.207,0.004,0.403,0.008,0.589c0.003,0.185,0.009,0.353,0.015,0.504
	c0.007,0.151,0.016,0.276,0.026,0.374l-0.372,0.26c-0.027-0.024-0.07-0.061-0.127-0.112c-0.058-0.051-0.117-0.104-0.179-0.158
	c-0.061-0.054-0.119-0.105-0.173-0.153c-0.054-0.047-0.093-0.082-0.117-0.102v-0.01c-0.119-0.295-0.28-0.548-0.484-0.757
	c-0.204-0.209-0.418-0.385-0.642-0.527c-0.207,0.241-0.451,0.426-0.731,0.555c-0.28,0.129-0.577,0.194-0.889,0.194
	c-0.228,0-0.458-0.036-0.69-0.109c-0.233-0.073-0.46-0.186-0.683-0.339c-0.223-0.153-0.437-0.349-0.642-0.589
	c-0.205-0.239-0.395-0.524-0.568-0.853c-0.109-0.204-0.208-0.415-0.298-0.634c-0.09-0.219-0.171-0.431-0.242-0.634
	c-0.071-0.204-0.134-0.394-0.188-0.571c-0.054-0.177-0.1-0.326-0.138-0.448c0.044-0.027,0.108-0.056,0.191-0.087
	c0.083-0.031,0.147-0.049,0.191-0.056c0.048,0.092,0.11,0.206,0.188,0.342c0.078,0.136,0.165,0.28,0.26,0.433
	c0.119,0.391,0.27,0.732,0.454,1.024c0.183,0.292,0.385,0.535,0.604,0.729c0.219,0.194,0.448,0.339,0.688,0.436
	c0.24,0.097,0.473,0.145,0.701,0.145c0.387,0,0.725-0.131,1.014-0.392c0.125-0.116,0.221-0.246,0.285-0.392
	c0.064-0.146,0.107-0.289,0.127-0.428c0.02-0.139,0.024-0.268,0.01-0.387c-0.014-0.119-0.034-0.21-0.061-0.275
	c-0.075-0.088-0.166-0.155-0.275-0.199c-0.109-0.044-0.221-0.066-0.336-0.066c-0.034,0-0.058,0.002-0.071,0.005
	c0.003,0.01,0.005,0.036,0.005,0.076c0,0.122-0.024,0.239-0.071,0.351c-0.048,0.112-0.114,0.21-0.199,0.293
	c-0.085,0.083-0.188,0.15-0.308,0.201c-0.121,0.051-0.254,0.076-0.4,0.076c-0.129,0-0.252-0.027-0.369-0.082
	c-0.117-0.054-0.22-0.127-0.308-0.219c-0.088-0.092-0.158-0.199-0.209-0.324c-0.051-0.124-0.076-0.256-0.076-0.395v-0.005
	c0-0.16,0.031-0.302,0.092-0.428c0.061-0.126,0.145-0.233,0.252-0.321c0.107-0.088,0.234-0.156,0.382-0.204
	c0.148-0.047,0.31-0.073,0.486-0.076c0.115,0,0.248,0.013,0.398,0.038c0.149,0.026,0.305,0.073,0.466,0.143
	c0.161,0.07,0.323,0.166,0.484,0.288c0.161,0.122,0.312,0.28,0.451,0.474c0.224,0.309,0.366,0.623,0.425,0.94
	c0.06,0.318,0.064,0.616,0.013,0.894c0.075,0.102,0.146,0.211,0.214,0.326c0.068,0.116,0.132,0.231,0.194,0.347
	c0.061,0.116,0.117,0.229,0.168,0.339c0.051,0.11,0.095,0.213,0.132,0.308c-0.004,0,0.009-0.003,0.036-0.01
	c-0.017-0.088-0.031-0.19-0.041-0.306c-0.01-0.116-0.015-0.25-0.015-0.403v-1.075c0-0.377-0.001-0.735-0.003-1.075
	c-0.002-0.34-0.003-0.649-0.003-0.927V9.739H5.474L5,9.214z"
      />
      <path
        fill={primaryColor}
        d="M14.567,12.044c0.102,0,0.244-0.001,0.428-0.003c0.184-0.002,0.39-0.003,0.619-0.005
	c0.229-0.002,0.472-0.004,0.729-0.008c0.257-0.004,0.512-0.007,0.767-0.01c0.598-0.004,1.24-0.009,1.926-0.015l0.178,0.224
	c-0.027,0.037-0.054,0.073-0.081,0.107c-0.027,0.034-0.054,0.068-0.081,0.102c-0.048,0.058-0.098,0.12-0.15,0.186
	c-0.053,0.066-0.103,0.125-0.15,0.176c-0.102,0-0.244,0.001-0.428,0.003c-0.183,0.002-0.389,0.003-0.616,0.005
	c-0.228,0.002-0.471,0.004-0.729,0.008c-0.258,0.003-0.513,0.007-0.764,0.01c-0.299,0.003-0.607,0.007-0.925,0.01
	c-0.318,0.003-0.65,0.007-0.996,0.01l-0.173-0.229c0.068-0.098,0.138-0.196,0.211-0.293C14.403,12.225,14.482,12.133,14.567,12.044z
	"
      />
    </svg>
  );

FontDecrease.propTypes = {
  lang: string,
  height: string,
  width: string,
  backgroundColor: string,
  primaryColor: string,
};

const CommentIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
    <path
      d="M14 0H2a2 2 0 00-2 2v9a2 2 0 002 2h3v2.625a.374.374 0 00.375.375.36.36 0 00.222-.075L9.5 13H14a2 2 0 002-2V2a2 2 0 00-2-2zm.5 11a.5.5 0 01-.5.5H9l-.4.3-2.1 1.575V11.5H2a.5.5 0 01-.5-.5V2a.5.5 0 01.5-.5h12a.5.5 0 01.5.5z"
      data-name="Path 502"
      fill="#121212"
    />
  </svg>
);

const Bookmark = ({ height = "32", width = "32", backgroundColor = "#E0E0E0" }) => (
  <svg
    height={height}
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    enableBackground="new 0 0 24 24"
    xmlSpace="preserve"
  >
    <circle fill={backgroundColor} cx="12" cy="12" r="10" />
    <path
      fillOpacity="0.87"
      d="M8.111,7h7.778c0.129,0,0.253,0.051,0.344,0.142c0.091,0.091,0.142,0.215,0.142,0.344v9.37
	c0,0.041-0.01,0.08-0.029,0.116c-0.019,0.036-0.047,0.066-0.081,0.088c-0.034,0.022-0.073,0.035-0.113,0.039
	c-0.04,0.003-0.081-0.004-0.118-0.021L12,15.278l-4.033,1.8c-0.037,0.017-0.078,0.024-0.118,0.02
	c-0.04-0.003-0.079-0.016-0.113-0.038c-0.034-0.022-0.062-0.052-0.081-0.088c-0.019-0.036-0.03-0.076-0.03-0.116v-9.37
	c0-0.129,0.051-0.253,0.142-0.344C7.859,7.051,7.982,7,8.111,7L8.111,7z M15.403,15.733V7.972H8.597v7.761L12,14.214L15.403,15.733z
	 M12,12.59l-1.429,0.751l0.273-1.59l-1.155-1.127l1.597-0.232L12,8.944l0.715,1.447l1.597,0.232l-1.155,1.127l0.272,1.59L12,12.59z"
    />
  </svg>
);
Bookmark.propTypes = {
  height: string,
  width: string,
  backgroundColor: string,
};

const Email = ({ height = "32", width = "32", primaryColor = "#FFFFFF" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" height={height} width={width} viewBox="0 0 24 24" xmlSpace="preserve">
    <path
      fillOpacity="0.87"
      d="M12,2c5.523,0,10,4.477,10,10c0,5.523-4.477,10-10,10C6.477,22,2,17.523,2,12C2,6.477,6.477,2,12,2z"
    />
    <path
      fill={primaryColor}
      d="M16.666,8c0.552,0,1,0.447,1,1c0,0.314-0.148,0.61-0.4,0.8l-4.533,3.4c-0.238,0.177-0.562,0.177-0.8,0
	L7.4,9.8C7.148,9.61,7,9.314,7,9c0-0.553,0.448-1,1-1H16.666z M11.533,13.733c0.475,0.356,1.125,0.356,1.6,0l4.533-3.4v4.333
	c0,0.735-0.598,1.333-1.333,1.333H8.333C7.597,15.999,7,15.401,7,14.666v-4.333L11.533,13.733z"
    />
  </svg>
);

Email.propTypes = {
  height: string,
  width: string,
  primaryColor: string,
};

const BookmarkActive = ({ height = "32", width = "32", primaryColor = "#FFFFFF", backgroundColor = "#0573E6" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" height={height} width={width} viewBox="0 0 24 24" xmlSpace="preserve">
    <circle fill={backgroundColor} cx="12" cy="12" r="10" />
    <path
      fill={primaryColor}
      d="M8.111,7h7.778c0.129,0,0.253,0.051,0.344,0.142c0.091,0.091,0.142,0.215,0.142,0.344v9.37
	c0,0.041-0.01,0.08-0.029,0.116c-0.019,0.036-0.047,0.066-0.081,0.088c-0.034,0.022-0.073,0.035-0.113,0.039
	c-0.04,0.003-0.081-0.004-0.118-0.021L12,15.278l-4.033,1.8c-0.037,0.017-0.078,0.024-0.118,0.02
	c-0.04-0.003-0.079-0.016-0.113-0.038c-0.034-0.022-0.062-0.052-0.081-0.088c-0.019-0.036-0.03-0.076-0.03-0.116v-9.37
	c0-0.129,0.051-0.253,0.142-0.344C7.859,7.051,7.982,7,8.111,7L8.111,7z M12,12.59l1.429,0.751l-0.273-1.59l1.155-1.127
	l-1.597-0.232L12,8.944l-0.715,1.447l-1.597,0.232l1.155,1.127l-0.272,1.59L12,12.59z"
    />
  </svg>
);

BookmarkActive.propTypes = {
  height: string,
  width: string,
  primaryColor: string,
  backgroundColor: string,
};

const Print = ({ height = "32", width = "32", primaryColor = "#FFFFFF", opacity = "0.54" }) => (
  <svg height={height} width={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" xmlSpace="preserve">
    <circle fillOpacity={opacity} cx="12" cy="12" r="10" />
    <path
      fill={primaryColor}
      d="M9.5,14.5h5V17h-5V14.5z M15.5,16v-2.5h-7V16h-1c-0.133,0-0.26-0.053-0.354-0.146
	C7.053,15.76,7,15.633,7,15.5v-5c0-0.133,0.053-0.26,0.146-0.354C7.24,10.053,7.367,10,7.5,10h9c0.133,0,0.26,0.053,0.354,0.146
	C16.947,10.24,17,10.367,17,10.5v5c0,0.133-0.053,0.26-0.146,0.354C16.76,15.947,16.633,16,16.5,16H15.5z M8.5,11v1H10v-1H8.5z
	 M9.5,7h5c0.133,0,0.26,0.053,0.354,0.146C14.947,7.24,15,7.367,15,7.5V9H9V7.5c0-0.133,0.053-0.26,0.146-0.354
	C9.24,7.053,9.367,7,9.5,7z"
    />
  </svg>
);
Print.propTypes = {
  height: string,
  width: string,
  primaryColor: string,
  opacity: string,
};

const CopyLink = ({ width = "32", height = "32", primaryColor = "#FFFFFF", opacity = "0.87" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24">
    <path
      fillOpacity={opacity}
      d="M12,2c5.523,0,10,4.477,10,10c0,5.523-4.477,10-10,10C6.477,22,2,17.523,2,12C2,6.477,6.477,2,12,2z"
    />
    <path
      fill={primaryColor}
      d="M8.833,9.822c1.109-1.108,2.951-1.108,4.059,0c0.997,0.997,1.144,2.586,0.325,3.732l-0.022,0.032
	c-0.206,0.285-0.604,0.353-0.889,0.148c-0.287-0.205-0.355-0.604-0.149-0.889l0.022-0.032c0.456-0.64,0.385-1.515-0.171-2.071
	c-0.626-0.626-1.645-0.626-2.273,0L7.497,12.98c-0.628,0.61-0.628,1.645,0,2.273c0.554,0.556,1.431,0.628,2.069,0.171l0.032-0.04
	c0.287-0.188,0.686-0.122,0.889,0.166c0.206,0.287,0.139,0.686-0.148,0.891l-0.032,0.022c-1.164,0.819-2.718,0.688-3.714-0.307
	c-1.126-1.126-1.126-2.952,0-4.077L8.833,9.822z M14.714,14.784c-1.126,1.126-2.951,1.126-4.077,0
	c-0.997-0.997-1.126-2.568-0.307-3.714l0.022-0.032c0.188-0.285,0.586-0.353,0.889-0.148c0.287,0.188,0.355,0.586,0.149,0.889
	l-0.022,0.032c-0.457,0.622-0.385,1.515,0.171,2.071c0.626,0.626,1.645,0.626,2.273,0l2.237-2.239c0.628-0.628,0.628-1.663,0-2.273
	c-0.554-0.556-1.431-0.628-2.069-0.171l-0.032,0.022c-0.287,0.205-0.686,0.122-0.889-0.148c-0.205-0.287-0.139-0.685,0.148-0.89
	l0.032-0.023c1.146-0.819,2.717-0.689,3.714,0.307c1.126,1.126,1.126,2.952,0,4.076L14.714,14.784z"
    />
  </svg>
);
CopyLink.propTypes = {
  primaryColor: string,
  width: string,
  height: string,
  opacity: string,
};

const Instagram = ({ height = "32", width = "32", primaryColor = "#FFFFFF" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" height={height} width={width} viewBox="0 0 24 24" xmlSpace="preserve">
    <radialGradient
      id="instagramGradient"
      cx="-305.6342"
      cy="417.4308"
      r="1"
      gradientTransform="matrix(1.213717e-15 -19.8215 -18.4356 -1.128855e-15 7702.8989 -6034.5874)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" style={{ stopColor: "#FFDD55" }} />
      <stop offset="0.1" style={{ stopColor: "#FFDD55" }} />
      <stop offset="0.5" style={{ stopColor: "#FF543E" }} />
      <stop offset="1" style={{ stopColor: "#C837AB" }} />
    </radialGradient>
    <path
      fill="url(#instagramGradient)"
      d="M12,22c5.523,0,10-4.477,10-10c0-5.523-4.477-10-10-10C6.477,2,2,6.477,2,12C2,17.523,6.477,22,12,22
	z"
    />
    <radialGradient
      id="SVGID_00000083074949814060886470000005728333131052336572_"
      cx="-233.4234"
      cy="438.3436"
      r="1"
      gradientTransform="matrix(1.7391 8.6879 35.812 -7.1685 -15293.3682 5173.6724)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" style={{ stopColor: "#3771C8" }} />
      <stop offset="0.128" style={{ stopColor: "#3771C8" }} />
      <stop offset="1" style={{ stopColor: "#6600FF", stopOpacity: 0 }} />
    </radialGradient>
    <path
      fill="url(#SVGID_00000083074949814060886470000005728333131052336572_)"
      d="M12,22c5.523,0,10-4.477,10-10
	c0-5.523-4.477-10-10-10C6.477,2,2,6.477,2,12C2,17.523,6.477,22,12,22z"
    />
    <path
      fill={primaryColor}
      d="M12.001,5.75c-1.698,0-1.911,0.008-2.577,0.037C8.758,5.818,8.304,5.923,7.907,6.078
	c-0.411,0.159-0.76,0.373-1.108,0.721C6.452,7.146,6.238,7.495,6.078,7.906C5.923,8.303,5.818,8.757,5.787,9.422
	C5.758,10.089,5.75,10.302,5.75,12s0.008,1.91,0.037,2.576c0.031,0.666,0.136,1.119,0.291,1.517c0.16,0.411,0.373,0.76,0.721,1.107
	c0.347,0.347,0.696,0.562,1.107,0.721c0.398,0.154,0.852,0.26,1.517,0.291c0.666,0.031,0.879,0.038,2.577,0.038
	s1.91-0.007,2.577-0.038c0.666-0.031,1.12-0.136,1.518-0.291c0.411-0.159,0.759-0.374,1.106-0.721
	c0.347-0.347,0.561-0.696,0.721-1.107c0.154-0.398,0.259-0.852,0.291-1.517C18.242,13.91,18.25,13.697,18.25,12
	s-0.007-1.911-0.038-2.577c-0.031-0.666-0.137-1.119-0.291-1.517c-0.16-0.411-0.374-0.76-0.721-1.107
	c-0.347-0.347-0.696-0.561-1.107-0.721c-0.399-0.154-0.853-0.26-1.518-0.291c-0.667-0.031-0.879-0.038-2.577-0.038H12.001z
	 M11.44,6.876c0.166,0,0.352,0,0.561,0c1.669,0,1.867,0.006,2.526,0.036c0.609,0.028,0.94,0.129,1.161,0.215
	c0.292,0.113,0.499,0.249,0.718,0.468c0.219,0.219,0.354,0.427,0.467,0.719c0.086,0.22,0.188,0.551,0.215,1.16
	c0.03,0.659,0.036,0.857,0.036,2.525s-0.006,1.866-0.036,2.525c-0.028,0.609-0.13,0.94-0.215,1.16
	c-0.113,0.292-0.249,0.499-0.467,0.718c-0.219,0.219-0.426,0.354-0.718,0.468c-0.22,0.086-0.551,0.188-1.161,0.216
	c-0.659,0.03-0.857,0.036-2.526,0.036c-1.669,0-1.867-0.006-2.526-0.036c-0.609-0.028-0.94-0.13-1.161-0.216
	c-0.292-0.113-0.5-0.249-0.719-0.468c-0.219-0.219-0.354-0.427-0.467-0.718c-0.086-0.22-0.188-0.551-0.215-1.16
	c-0.03-0.659-0.036-0.857-0.036-2.526c0-1.669,0.006-1.866,0.036-2.525c0.028-0.609,0.129-0.94,0.215-1.161
	c0.113-0.292,0.249-0.5,0.467-0.719s0.427-0.354,0.719-0.468C8.534,7.04,8.866,6.938,9.475,6.91c0.576-0.026,0.8-0.034,1.965-0.035
	V6.876z M15.337,7.914c-0.414,0-0.75,0.336-0.75,0.75c0,0.414,0.336,0.75,0.75,0.75c0.414,0,0.75-0.336,0.75-0.75
	C16.087,8.25,15.751,7.914,15.337,7.914z M12.001,8.791c-1.773,0-3.209,1.437-3.209,3.209s1.437,3.209,3.209,3.209
	S15.21,13.772,15.21,12S13.773,8.791,12.001,8.791z M12.001,9.917c1.151,0,2.083,0.933,2.083,2.083s-0.933,2.083-2.083,2.083
	c-1.151,0-2.083-0.933-2.083-2.083C9.917,10.849,10.85,9.917,12.001,9.917z"
    />
  </svg>
);

Instagram.propTypes = {
  height: string,
  width: string,
  primaryColor: string,
};

const Linkedin = ({ height = "32", width = "32", backgroundColor = "#2A67B2", primaryColor = "#FFFFFF" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" height={height} width={width} viewBox="0 0 24 24" xmlSpace="preserve">
    <path
      fill={backgroundColor}
      d="M12,22c-2.652,0-5.196-1.054-7.071-2.929C3.054,17.196,2,14.652,2,12c0-2.652,1.054-5.196,2.929-7.071
	C6.804,3.054,9.348,2,12,2c2.652,0,5.196,1.054,7.071,2.929C20.946,6.804,22,9.348,22,12c0,2.652-1.054,5.196-2.929,7.071
	C17.196,20.946,14.652,22,12,22z"
    />
    <path fill={primaryColor} d="M9.535,9.771h-2.07v6.686h2.07V9.771z" />
    <path
      fill={primaryColor}
      d="M8.49,8.897c0.244,0.002,0.484-0.068,0.688-0.203C9.383,8.56,9.542,8.368,9.637,8.143
	C9.732,7.918,9.759,7.67,9.712,7.43C9.666,7.19,9.549,6.969,9.377,6.795C9.205,6.621,8.986,6.503,8.746,6.454
	c-0.24-0.049-0.488-0.025-0.714,0.068c-0.226,0.093-0.42,0.251-0.556,0.454C7.34,7.178,7.267,7.417,7.267,7.662
	c-0.001,0.161,0.03,0.321,0.091,0.471c0.061,0.149,0.151,0.285,0.265,0.4C7.736,8.647,7.871,8.739,8.02,8.801
	C8.169,8.864,8.329,8.896,8.49,8.897z"
    />
    <path
      fill={primaryColor}
      d="M12.844,12.947c0-0.94,0.433-1.5,1.261-1.5c0.758,0,1.126,0.537,1.126,1.5v3.509h2.06v-4.233
	c0-1.791-1.015-2.653-2.433-2.653c-0.403-0.006-0.8,0.093-1.153,0.287c-0.353,0.194-0.65,0.475-0.862,0.818V9.771h-1.985v6.686
	h1.985V12.947z"
    />
  </svg>
);

Linkedin.propTypes = {
  height: string,
  width: string,
  backgroundColor: string,
  primaryColor: string,
};

const Pinterest = ({ height = "32", width = "32", backgroundColor = "#E60023", primaryColor = "#FFFFFF" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" height={height} width={width} viewBox="0 0 24 24" xmlSpace="preserve">
    <path
      fill={backgroundColor}
      d="M12,22c5.523,0,10-4.477,10-10c0-5.523-4.477-10-10-10C6.477,2,2,6.477,2,12C2,17.523,6.477,22,12,22z"
    />
    <path
      fill={primaryColor}
      d="M12.222,5.708c-4.316,0-6.608,2.897-6.608,6.052c0,1.467,0.781,3.293,2.03,3.874
	c0.189,0.088,0.291,0.05,0.334-0.133c0.033-0.139,0.202-0.818,0.278-1.134c0.024-0.101,0.012-0.187-0.069-0.287
	c-0.413-0.502-0.744-1.423-0.744-2.282c0-2.206,1.67-4.34,4.515-4.34c2.457,0,4.176,1.674,4.176,4.068
	c0,2.705-1.366,4.579-3.143,4.579c-0.982,0-1.717-0.812-1.481-1.808c0.283-1.188,0.828-2.471,0.828-3.329
	c0-0.768-0.412-1.408-1.265-1.408c-1.003,0-1.809,1.038-1.809,2.428c0,0.885,0.299,1.484,0.299,1.484s-0.991,4.191-1.173,4.971
	c-0.201,0.861-0.123,2.071-0.036,2.862c0.226,0.088,0.451,0.177,0.684,0.249c0.408-0.664,1.018-1.753,1.243-2.621
	c0.122-0.468,0.624-2.377,0.624-2.377c0.326,0.622,1.278,1.149,2.291,1.149c3.016,0,5.189-2.774,5.189-6.22
	C18.387,8.18,15.691,5.708,12.222,5.708z"
    />
  </svg>
);

Pinterest.propTypes = {
  height: string,
  width: string,
  backgroundColor: string,
  primaryColor: string,
};

const PublisedTimeToggler = () => (
  <svg xmlns="http://www.w3.org/2000/svg" id="up-down" width="7.187" height="10" viewBox="0 0 7.187 10">
    <path
      id="Path_269"
      d="M17.539 62.754h5.978a.6.6 0 0 1 .427 1.03l-2.989 2.989a.6.6 0 0 1-.852 0l-2.992-2.989a.6.6 0 0 1 .428-1.03zm6.405-2.638l-2.989-2.989a.6.6 0 0 0-.852 0l-2.992 2.989a.6.6 0 0 0 .427 1.03h5.978a.6.6 0 0 0 .428-1.03z"
      data-name="Path 269"
      transform="translate(-16.934 -56.95)"
      fill="#00000061"
    ></path>
  </svg>
);

export {
  Facebook,
  Twitter,
  Youtube,
  Whatsapp,
  Share,
  FontIncrease,
  FontDecrease,
  Bookmark,
  BookmarkActive,
  Email,
  CopyLink,
  Print,
  Instagram,
  Linkedin,
  PublisedTimeToggler,
  CommentIcon,
  Pinterest,
};
